import angular from 'angular';

import alert from './alert/alert.module';
import appMenu from './app-menu/app-menu.module';
import appToolbar from './app-toolbar/app-toolbar.module';
import attest from './attest/attest.module';
import categoryAutocomplete from './autocomplete/category/category-autocomplete.module';
import changePassword from './change-password/change-password.module';
import companyAutocomplete from './autocomplete/company/company-autocomplete.module';
import dialogClose from './dialog-close/dialog-close.module';
import ingredientAutocomplete from './autocomplete/ingredient/ingredient-autocomplete.module';
import itemList from './item-list/item-list.module';
import feedback from './feedback/feedback.module';
import productLabelUpload from './product-label-upload/product-label-upload.module';
import regulatorAutocomplete from './autocomplete/regulator/regulator-autocomplete.module';
import userAddForm from './user-add-form/user-add-form.module';
import userEditForm from './user-edit-form/user-edit-form.module';
import userList from './user-list/user-list.module';

export default angular.module('components.app.common', [
  alert,
  appMenu,
  appToolbar,
  attest,
  categoryAutocomplete,
  changePassword,
  companyAutocomplete,
  dialogClose,
  feedback,
  ingredientAutocomplete,
  itemList,
  productLabelUpload,
  regulatorAutocomplete,
  userAddForm,
  userEditForm,
  userList
]).name;



// WEBPACK FOOTER //
// ./components/app/common/common.module.js